import { GTMProvider } from '@elgorditosalsero/react-gtm-hook';
import * as React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { HelmetProvider } from 'react-helmet-async';
import { I18nextProvider } from 'react-i18next';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter as Router } from 'react-router-dom';

import { ErrorPage } from '@/components/Layout/ErrorPage';
import { Notifications } from '@/components/Notifications/Notifications';
import GTM from '@/lib/gtm/gtm';
import i18n from '@/lib/i18n/i18n';
import { queryClient } from '@/lib/react-query';

import { ThemeProvider } from './theming';

const myErrorHandler = (error: Error, info: { componentStack: string }) => {
  // Do something with the error
  // E.g. log to an error logging client here
  console.info('Error Handler: ', error, info);
};

type AppProviderProps = {
  children: React.ReactNode;
};

export const AppProvider = ({ children }: AppProviderProps) => {
  return (
    <>
      <ErrorBoundary FallbackComponent={ErrorPage} onError={myErrorHandler}>
        <HelmetProvider>
          <GTMProvider state={GTM}>
            <I18nextProvider i18n={i18n}>
              <ThemeProvider>
                <QueryClientProvider client={queryClient}>
                  {process.env.NODE_ENV !== 'production' && <ReactQueryDevtools />}
                  <Notifications />
                  <Router>{children}</Router>
                </QueryClientProvider>
              </ThemeProvider>
            </I18nextProvider>
          </GTMProvider>
        </HelmetProvider>
      </ErrorBoundary>
    </>
  );
};
